/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Stat_Iowa_InstructorInputs */

const en_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa Instructor`)
};

const es_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructor de Iowa`)
};

const de_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golflehrer in Iowa`)
};

const zh_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`爱荷华州教练`)
};

const ar_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدرب الغولف في Iowa`)
};

const fr_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructeur de l’Iowa`)
};

const vi_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huấn luyện viên Iowa`)
};

const sw_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mkufunzi wa Iowa`)
};

const th_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้ฝึกสอนในไอโอวา`)
};

const bs_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruktor u Iowi`)
};

const ja_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイオワ州のインストラクター`)
};

const ko_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa 강사`)
};

const pt_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrutor de Iowa`)
};

const it_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istruttore in Iowa`)
};

const sv_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruktör i Iowa`)
};

const nl_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfleraar in Iowa`)
};

const da_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruktør i Iowa`)
};

const nb_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruktør i Iowa`)
};

const fi_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfopettaja Iowassa`)
};

const pl_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruktor w Iowa`)
};

const ru_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инструктор в Iowa`)
};

const tr_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa Eğitmeni`)
};

const hi_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa में प्रशिक्षक`)
};

const id_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruktur Iowa`)
};

const ms_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jurulatih Iowa`)
};

const cs_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruktor v Iowě`)
};

const el_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εκπαιδευτής στην Iowa`)
};

const he_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מדריך ב-Iowa`)
};

const af_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrukteur in Iowa`)
};

const hu_home_stat_iowa_instructor = /** @type {(inputs: Home_Stat_Iowa_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oktató Iowában`)
};

/**
* | output |
* | --- |
* | "Iowa Instructor" |
*
* @param {Home_Stat_Iowa_InstructorInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_stat_iowa_instructor = /** @type {((inputs?: Home_Stat_Iowa_InstructorInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Stat_Iowa_InstructorInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_stat_iowa_instructor(inputs)
	if (locale === "de") return de_home_stat_iowa_instructor(inputs)
	if (locale === "zh") return zh_home_stat_iowa_instructor(inputs)
	if (locale === "ar") return ar_home_stat_iowa_instructor(inputs)
	if (locale === "fr") return fr_home_stat_iowa_instructor(inputs)
	if (locale === "vi") return vi_home_stat_iowa_instructor(inputs)
	if (locale === "sw") return sw_home_stat_iowa_instructor(inputs)
	if (locale === "th") return th_home_stat_iowa_instructor(inputs)
	if (locale === "bs") return bs_home_stat_iowa_instructor(inputs)
	if (locale === "ja") return ja_home_stat_iowa_instructor(inputs)
	if (locale === "ko") return ko_home_stat_iowa_instructor(inputs)
	if (locale === "pt") return pt_home_stat_iowa_instructor(inputs)
	if (locale === "it") return it_home_stat_iowa_instructor(inputs)
	if (locale === "sv") return sv_home_stat_iowa_instructor(inputs)
	if (locale === "nl") return nl_home_stat_iowa_instructor(inputs)
	if (locale === "da") return da_home_stat_iowa_instructor(inputs)
	if (locale === "nb") return nb_home_stat_iowa_instructor(inputs)
	if (locale === "fi") return fi_home_stat_iowa_instructor(inputs)
	if (locale === "pl") return pl_home_stat_iowa_instructor(inputs)
	if (locale === "ru") return ru_home_stat_iowa_instructor(inputs)
	if (locale === "tr") return tr_home_stat_iowa_instructor(inputs)
	if (locale === "hi") return hi_home_stat_iowa_instructor(inputs)
	if (locale === "id") return id_home_stat_iowa_instructor(inputs)
	if (locale === "ms") return ms_home_stat_iowa_instructor(inputs)
	if (locale === "cs") return cs_home_stat_iowa_instructor(inputs)
	if (locale === "el") return el_home_stat_iowa_instructor(inputs)
	if (locale === "he") return he_home_stat_iowa_instructor(inputs)
	if (locale === "af") return af_home_stat_iowa_instructor(inputs)
	if (locale === "hu") return hu_home_stat_iowa_instructor(inputs)
	return en_home_stat_iowa_instructor(inputs)
});